import { Link } from "react-router-dom";

const entries = [
  {
    to: "/works",
    icon: "ri-film-line",
    title: "影视作品",
    desc: "电影 · 电视剧 · 全类型作品库",
    count: "12+ 部作品",
    tone: "primary",
  },
  {
    to: "/stars",
    icon: "ri-user-star-line",
    title: "明星资讯",
    desc: "签约演员 · 主创团队名录",
    count: "12 位演员",
    tone: "accent",
  },
  {
    to: "/news",
    icon: "ri-newspaper-line",
    title: "影视动态",
    desc: "新闻 · 活动 · 官方公告",
    count: "10+ 条动态",
    tone: "secondary",
  },
] as const;

const toneClass: Record<string, string> = {
  primary: "bg-primary-100 text-primary-700",
  accent: "bg-accent-100 text-accent-700",
  secondary: "bg-secondary-100 text-secondary-700",
};

export default function CategoryEntries() {
  return (
    <section className="mx-auto w-full max-w-page px-4 md:px-6">
      <div className="grid grid-cols-1 gap-4 sm:grid-cols-3 md:gap-5">
        {entries.map((entry, i) => (
          <Link
            key={entry.to}
            to={entry.to}
            className="group flex items-center gap-4 rounded-lg border border-background-200 bg-background-50 p-4 transition-all duration-300 hover:border-primary-300 md:p-5 animate-fade-up"
            style={{ animationDelay: `${i * 80}ms` }}
          >
            <span className={`flex h-14 w-14 shrink-0 items-center justify-center rounded-lg text-2xl ${toneClass[entry.tone]}`}>
              <i className={entry.icon}></i>
            </span>
            <span className="min-w-0 flex-1">
              <span className="flex items-center gap-2">
                <span className="text-base font-bold text-foreground-950 transition-colors group-hover:text-primary-700">
                  {entry.title}
                </span>
                <span className="flex h-4 w-4 items-center justify-center text-foreground-400 transition-transform group-hover:translate-x-0.5">
                  <i className="ri-arrow-right-line text-base"></i>
                </span>
              </span>
              <span className="mt-0.5 block truncate text-xs text-foreground-500">{entry.desc}</span>
              <span className="mt-1 block text-xs font-medium text-accent-600">{entry.count}</span>
            </span>
          </Link>
        ))}
      </div>
    </section>
  );
}